module.exports = __webpack_public_path__ + "img/logo.364a3941.png";